import { Injectable } from "@angular/core";
import { AppRootService, IGlobalAppConfig } from "app/shared/services/app-root/app-root-service";
import { IQuotationsQuotation } from "libraries/service/resources/quotation-quotations/IQuotationsQuotation";
import { Yii } from "libraries/interfaces/Yii";
import { InstanceService } from "libraries/service/instance/instance.service";
import { TabCode } from "app/shared/model/ITab";
import { EQuotationEntryPoints } from "libraries/enums/e-quotation-entry-points";

@Injectable()
export class CostAppConfigService {
    constructor(
        private readonly appRootService: AppRootService,
        private readonly instanceService: InstanceService,
    ) { }

    public prepareConfig(quotation: IQuotationsQuotation): IGlobalAppConfig {
        const appConfig: IGlobalAppConfig = this.constructCostAppConfig(quotation);
        this.appRootService.setAppConfig(appConfig);
        this.appRootService.setBrowserTitle();

        return appConfig;
    }

    private constructCostAppConfig(quotation: IQuotationsQuotation): IGlobalAppConfig {
        let appConfig: IGlobalAppConfig = {
            ...this.appRootService.getAppConfig(this.appRootService.getCurrentAppFromLocation()),
            routerLink: `${this.instanceService.fullUrl}wui_watabi/item/${quotation.externalReference.code}#quotes`,
            canEditTitle: !quotation.isReadOnly,
            tabs: [
                {
                    code: EQuotationEntryPoints.cost,
                    disabled: false,
                    allow: true,
                    label: Yii.t('wui-quotation-js', 'Achat'),
                    tabDetector: `/quotation/${quotation.id}/cost`,
                    routerLink: `/quotation/${quotation.id}/cost/included`,
                    tabs: [
                        {
                            code: TabCode.included,
                            allow: true,
                            disabled: false,
                            active: true,
                            label: Yii.t('wui-quotation-js', 'Inclus'),
                            tabDetector: `/quotation/${quotation.id}/cost/included`,
                            routerLink: `/quotation/${quotation.id}/cost/included`
                        },
                        {
                            code: TabCode.option,
                            allow: true,
                            disabled: false,
                            active: false,
                            label: Yii.t('wui-quotation-js', 'En option'),
                            tabDetector: `/quotation/${quotation.id}/cost/option`,
                            routerLink: `/quotation/${quotation.id}/cost/option`
                        },
                    ]
                },
                {
                    code: EQuotationEntryPoints.retail,
                    allow: true,
                    disabled: false,
                    label: Yii.t('wui-quotation-js', 'Vente'),
                    tabDetector: `/quotation/${quotation.id}/retail`,
                    routerLink: `/quotation/${quotation.id}/retail/included`,
                    tabs: [
                        {
                            code: TabCode.included,
                            allow: true,
                            disabled: false,
                            active: true,
                            label: Yii.t('wui-quotation-js', 'Inclus'),
                            tabDetector: `/quotation/${quotation.id}/retail/included`,
                            routerLink: `/quotation/${quotation.id}/retail/included`
                        },
                        {
                            allow: true,
                            code: TabCode.option,
                            disabled: false,
                            active: false,
                            label: Yii.t('wui-quotation-js', 'En option'),
                            tabDetector: `/quotation/${quotation.id}/retail/option`,
                            routerLink: `/quotation/${quotation.id}/retail/option`
                        },
                    ]
                }
            ]
        };

        if (quotation.title) {
            appConfig = {
                ...appConfig,
                secondaryName: quotation.title
            };
        }

        return appConfig;
    }
}
